import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { first } from 'rxjs/operators';
import { ApiService } from '../../../_services/api.service';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss']
})
export class VerificationComponent implements OnInit {

  id: any;
  response: any;
  businessData: any;
  hiringCertificate: boolean = false;
  type: any;
  constructor(private route: ActivatedRoute,
    private api: ApiService,
    private ngxUiLoaderService: NgxUiLoaderService) {
    if (this.route.snapshot.paramMap.get('id')) {
      this.id = this.route.snapshot.paramMap.get('id');
      this.type = this.route.snapshot.queryParamMap.get('type');
      console.log("25", this.id)
      console.log("25", this.type)
    }
  }

  ngOnInit() {
    if (this.id && this.type == 'hiringform') {
      this.hiringCertificate = true;
      this.getEmployeeData();
    } else {
      this.hiringCertificate = false;
      this.getBusinessData();
    }
  }

  getBusinessData() {
    var data = {
      uuid: this.id
    }
    this.ngxUiLoaderService.start();
    this.api.verificationCheckByQr(data).pipe(first())
      .subscribe(data => {
          console.log(data)
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            this.businessData = this.response.companyDetails;
            console.log(this.hiringCertificate)
          } else {
            this.businessData = '';
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  getEmployeeData() {
    var data = {
      uuid: this.id
    }
    this.ngxUiLoaderService.start();
    this.api.employeeVerificationCheckQr(data).pipe(first())
      .subscribe(data => {
          console.log(data)
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            this.businessData = this.response.result;
            console.log("this.businessData",this.businessData)
            console.log(this.hiringCertificate)
          } else {
            this.businessData = '';
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }
}
